<template>
    <div class="text-a-blue-001b73" data-cy="container_confirm_redeem_default">
        <div class="text-20 font-medium mb-2" data-cy="text_confirm_redeem_title">{{title}}</div>
        <p v-if="campaign.pointType != 'get'" class="text-16 font-regular" data-cy="text_confirm_redeem_campaign_name" v-html="redeemPoint()"></p>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: 'DefaultConfirmRedeem',
    mixins: [LocaleMixin],
    props: {
        campaign: Object
    },
    data: function () {
        return {
            title: '',
            msg: ''
        };
    },
    created: function () {
        var minutes = this.campaign.minutesValidAfterUsed;
        if (minutes) {
            let days = '';
            let hours = '';
            let result = '';
            if (minutes >= 60) {
                hours = Math.floor(minutes / 60);
                if (hours >= 24) {
                    days = Math.floor(hours / 24);
                }
            }

            if (days > 0) {
                result += days + ' ' + this.lbl.date.days + ' ';
            }

            if (hours / 24 > 0) {
                result += (hours % 24) + ' ' + this.lbl.date.hours + ' ';
            }

            if (minutes / 60 > 0) {
                result += (minutes % 60) + ' ' + this.lbl.date.minutes_short;
            }

            this.title = this.lbl.confirm_redeem.default;
            this.msg = Util.stringFormat(this.lbl.confirm_redeem.defualt_have_time, result);
        } else {
            this.title = this.lbl.confirm_redeem.default;
            this.msg = this.lbl.confirm_redeem.default;
        }
    },
    methods: {
        redeemPoint: function() {
            var point = this.campaign.pointPerUnit;
            this.text = Util.stringFormat(this.lbl.confirm_redeem.msg_free_deal, point);
            return this.text;
        }
    }
}
</script>
